import { SingleValue } from 'react-select';

import Pipeline from 'types/pipeline';
import { DataWidgetFiltersInput } from 'dashboards/types/filter';

import { usePipelines } from 'pipelines/hooks/usePipelines';

import { PipelineSelect } from 'pipelines/components/PipelineSelect/PipelineSelect';

import { Placeholder } from './SuggestionInput';
import { filterIds } from '../service';
import { useDataWidgetFiltersInputState } from '../context';

type PipelinesFilterInputProps = Pick<DataWidgetFiltersInput, 'id' | 'value'>;

export function PipelineFilterInput({ id, value }: PipelinesFilterInputProps) {
  const { filters, updateFilter } = useDataWidgetFiltersInputState();

  const pipelineIds = filterIds('pipeline_id', filters);

  const { data: pipelines, isInitialLoading } = usePipelines({
    params: { pipeline_ids: pipelineIds },
    enabled: Boolean(pipelineIds.length),
    keepPreviousData: true,
  });

  if (!pipelines && isInitialLoading) {
    return Placeholder;
  }

  function handlePipelineChange(pipeline: SingleValue<Pipeline>) {
    if (!pipeline) {
      return;
    }

    updateFilter(id, { value: pipeline.id });
  }

  return (
    <PipelineSelect
      defaultValue={pipelines?.data.find(({ id }) => id === value)}
      onChange={handlePipelineChange}
      styles={{
        menu: (provided) => ({
          ...provided,
          width: 'auto',
        }),
      }}
    />
  );
}
